import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'socialSecurity' })

export class SocialSecurityPipe implements PipeTransform {
    transform(value: string | null | undefined) {
        // if (value == null || value === '') return '';
        // if (!(typeof String(value))) return value;
        // if (value.length !== 9) return value;

        // return value.substr(0, 3) + '-' + value.substr(3, 2) + '-' + value.substr(5, 4);

        if (!value) return '';
        if (value.length !== 9) return value;

        return value.substr(0, 3) + '-' + value.substr(3, 2) + '-' + value.substr(5, 4);
    }
}